const EMAILJS_URL = 'https://api.emailjs.com/api/v1.0/email/send'
// Zoho service — mail leaves as info@206gravel.com. This ID must match a
// service that still exists in the EmailJS dashboard: deleting a service makes
// every send fail, which surfaces to customers as "couldn't reach dispatch".
const EMAILJS_SERVICE_ID = 'service_y59em1r'
const EMAILJS_TEMPLATE_ID = 'template_7kxwckd'
const EMAILJS_PUBLIC_KEY = 'jPcnxBxjvJjl5Qnb_'

// Business inbox every form submission lands in — orders, quotes, contact
// messages, and dispatch notices. Single constant so the destination can never
// drift between forms.
const DISPATCH_INBOX = 'info@206gravel.com'

interface FormPayload {
  subject: string
  [key: string]: string | number | boolean | undefined
}

export async function sendFormEmail(data: FormPayload): Promise<boolean> {
  try {
    // Extract FormSubmit-specific fields and map to EmailJS equivalents
    const { _replyto, _autoresponse, _cc, _captcha, _template, ...cleanData } =
      data as Record<string, any>

    const res = await fetch(EMAILJS_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        service_id: EMAILJS_SERVICE_ID,
        template_id: EMAILJS_TEMPLATE_ID,
        user_id: EMAILJS_PUBLIC_KEY,
        template_params: {
          ...cleanData,
          // EmailJS uses to_email for the main recipient
          to_email: DISPATCH_INBOX,
          // EmailJS uses reply_to for the auto-reply recipient
          reply_to: _replyto || cleanData.email || '',
          // Pass auto-response text so the template can use it
          auto_response: _autoresponse || '',
        },
      }),
    })
    if (!res.ok) {
      // EmailJS returns the reason as plain text (e.g. an unverified sender or
      // a service/template mismatch). Surface it — a bare `false` here reads as
      // "dispatch is unreachable" and hides a config problem.
      const reason = await res.text().catch(() => '')
      console.error(`EmailJS send failed (${res.status}): ${reason}`)
      return false
    }
    return true
  } catch (err) {
    console.error('Form submission error:', err)
    return false
  }
}
